import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useSpareItem, SpareItem } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<SpareItem>
    useData={useSpareItem}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
